import { useEffect, useState } from 'react';

import { PlanToIfcDialog } from 'app/modules/wallforming/components/plan-to-ifc/PlanToIfcDialog';
import { projectsMenuEvents } from 'app/modules/wallforming/components/projects-manager/types/projectsMenuEvents';

/** Opens the plan-to-IFC dialog from the projects menu event bus. */
export const PlanToIfcManager = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const onOpen = () => setIsOpen(true);
        window.addEventListener(projectsMenuEvents.openPlanToIfc, onOpen);
        return () => window.removeEventListener(projectsMenuEvents.openPlanToIfc, onOpen);
    }, []);

    return isOpen ? <PlanToIfcDialog onClose={() => setIsOpen(false)} /> : null;
};
